export default "__VITE_ASSET__gJDMzU2n__"